import PropTypes from 'prop-types';
import Button from '@components/buttons/button.jsx';
import discordScreenshot from '@assets/chatbots/screenshots/discord-screenshot.jpg';

DiscordChatbotSetup.propTypes = {
  connectURL: PropTypes.string.isRequired,
};

export default function DiscordChatbotSetup({ connectURL }) {
  return (
    <div>
      <div className="flex flex-col">
        <div>
          <img
            className="rounded-md"
            src={`${discordScreenshot}`}
            alt="Discord Screenshot"
          />
        </div>
        <article className="prose mt-1 mb-2 flex-grow">
          <p className="mb-4 mt-6">
            To connect and setup the Discord bot, simply click the 'Connect'
            button.
          </p>
          <Button
            analyticsTrackingName="discord-chatbot-connect"
            style="primary"
            type="regular"
            mode="link"
            className="min-w-28"
            href={connectURL}
          >
            Connect
          </Button>
        </article>
      </div>
      <div className="divider" />
    </div>
  );
}
